import { FC } from 'react'

import { Comment, ConceptDayComment, DayComment } from '../../../../../../@paco/entities/Comment/Comment'
import { getPersonFullName } from '../../../../../../@paco/entities/Person/PersonHelpers'
import trans from '../../../../../../@paco/helpers/trans'

import './CalendarNote.scss'

export interface CalendarNoteProps {
    comment: DayComment | ConceptDayComment | Comment;
    className?: string;
    onDeleteClick?: (commentId: string) => void;
}

export const CalendarNote: FC<CalendarNoteProps> = ({
    comment,
    className = '',
    onDeleteClick,
}) => {
    const handleDeleteClick = () => {
        onDeleteClick?.(comment.id)
    }

    return (
        <div className={`calendar-note ${className}`}>
            <div className="calendar-note__content">
                {'baseSchedule' in comment && comment.baseSchedule && (
                    <p className="calendar-note__base-schedule">
                        {trans('compositions.calendarNote.fromBaseSchedule')} <strong>{comment.baseSchedule.name}</strong>
                    </p>
                )}

                {comment.owner && (
                    <span className="calendar-note__owner">
                        {getPersonFullName(comment.owner.person)}
                        :
                    </span>
                )}
                <p className="calendar-note__body">{comment.body}</p>
            </div>

            {onDeleteClick && (
                <button className="calendar-note__delete-button" type="button" onClick={handleDeleteClick}>
                    {trans('common.delete')}
                </button>
            )}
        </div>
    )
}
